import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAnatomicMap } from '@se/ui.anatomic.map';
import { ServerRootService } from '@se/se.ui.html5';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class MapLoaderService {
    private path: string;
    private devMode: boolean;

    constructor(private http: HttpClient, private serverRoot: ServerRootService) {
        const customPagesSiteRoot: string = this.serverRoot.getCustomPagesSiteRoot();

        this.devMode = customPagesSiteRoot.indexOf("localhost") !== -1;

        if (this.devMode) {
            this.path = 'mocks/IAnatomicMaps/';
        } else {
            this.path = customPagesSiteRoot + 'maps/'
        }
    }

    load(filename: string): Observable<IAnatomicMap> {
        return this.http.get<IAnatomicMap>(this.path + filename + '.json').pipe(
            map(res => {
                res.pathImg = res.pathImg ? this.path + res.pathImg : undefined;
                return res;
            })
        );
    }
}
